const tokensDE = {
    "view": {
        "title": "Token-Verlauf",
        "table": {
            "column": {
                "quantity": "Menge",
                "description": "Beschreibung",
                "type": "Typ",
                "balance": "Kontostand",
                "date": "Datum",
                "receipt": "Beleg"
            },
            "placeholder": {
                "search": "Suchen..."
            },
            "button": {
                "view": "Anzeigen",
                "export_csv": "CSV exportieren",
                "order_tokens": "Token bestellen"
            },
            "label": {
                "not_available": "Nicht verfugbar",
                "credit": "Gutschrift",
                "debit": "Lastschrift"
            }
        }
    },
    "order": {
        "title": "Token bestellen",
        "form": {
            "label": {
                "quantity": "Menge"
            },
            "placeholder": {
                "quantity": "Menge auswahlen"
            },
            "help": {
                "quantity": "Anzahl der Token, die Sie bestellen mochten."
            },
            "validation": {
                "quantityRequired": "Menge ist erforderlich"
            },
            "button": {
                "placeOrder": "Bestellung aufgeben"
            },
            "option": {
                "tokensAmount": "{{count}} Token"
            }
        },
        "modal": {
            "title": "Zur Kasse gehen",
            "orderedPrefix": "Sie haben bestellt",
            "description": "Wenn Sie die Bestellung bestatigen mochten, gehen Sie bitte zur Kasse. Andernfalls konnen Sie die Bestellung abbrechen.",
            "button": {
                "cancel": "Abbrechen",
                "checkout": "Zur Kasse"
            }
        },
        "message": {
            "error": "Etwas ist schiefgelaufen! Bitte laden Sie die Seite neu und versuchen Sie es erneut!"
        }
    },
    "transaction": {
        "success": {
            "title": "Transaktion erfolgreich :)",
            "description": "Sie haben die Token erfolgreich gekauft. Sie werden in Kurze Ihrem Konto hinzugefugt!"
        },
        "cancel": {
            "title": "Transaktion abgebrochen :(",
            "description": "Die Transaktion wurde abgebrochen... Bitte versuchen Sie es spater erneut!"
        },
        "button": {
            "returnToDashboard": "Zuruck zum Dashboard"
        }
    }
};

export default tokensDE;
